var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.25,
    height: 29.25,
    viewBox: "0 0 29.25 29.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-paper",
    "data-name": "Icon ionic-ios-paper",
    d: "M8.719,5.625V28.266a.987.987,0,0,1-.984.984h0a.987.987,0,0,1-.984-.984V7.875H5.625a2.248,2.248,0,0,0-2.25,2.25v20.25a2.248,2.248,0,0,0,2.25,2.25H30.452a2.174,2.174,0,0,0,2.173-2.173V5.625a2.248,2.248,0,0,0-2.25-2.25l-19.547.141A2.015,2.015,0,0,0,8.719,5.625Zm4.641,2.25h5.906a.987.987,0,0,1,.984.984h0a.987.987,0,0,1-.984.984H13.359a.987.987,0,0,1-.984-.984h0A.987.987,0,0,1,13.359,7.875Zm0,11.25H23.766a.987.987,0,0,1,.984.984h0a.987.987,0,0,1-.984.984H13.359a.987.987,0,0,1-.984-.984h0A.987.987,0,0,1,13.359,19.125Zm13.781,7.594H13.359a.987.987,0,0,1-.984-.984h0a.987.987,0,0,1,.984-.984H27.141a.987.987,0,0,1,.984.984h0A.987.987,0,0,1,27.141,26.719Zm0-11.25H13.359a.987.987,0,0,1-.984-.984h0a.987.987,0,0,1,.984-.984H27.141a.987.987,0,0,1,.984.984h0A.987.987,0,0,1,27.141,15.469Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#774f9f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaper);
export default __webpack_public_path__ + "static/media/icon-paper.02c46f352af782a8fabb5025a2f039d0.svg";
export { ForwardRef as ReactComponent };